import { InvalidatesTags } from '../..'

export interface GetPaymentRescheduleRequest {
  params: {
    paymentScheduleId: string
  }
}

export interface GetPaymentRescheduleResponseBody {
  newPaymentDateOptions: string[]
  changePaymentDate: {
    optedIn: boolean
    benefitDescription: string
    label?: string
    reschedulesRemaining?: number
  }
}

export interface SetPaymentRescheduleRequest {
  params: {
    paymentScheduleId: string
  }
  body: {
    newPaymentDate: string
  }
  cache: {
    invalidatesTags: InvalidatesTags
  }
}

export enum PaymentRescheduleErrorCode {
  CHANGE_PAYMENT_SCHEDULE_MAX_CHANGES_ON_ORDER = 'change_payment_schedule_max_changes_on_order',
  CHANGE_PAYMENT_SCHEDULE_MERCHANT_BLACKLISTED = 'change_payment_schedule_merchant_blacklisted',
  CHANGE_PAYMENT_SCHEDULE_RESTRICTED_PAYMENTS = 'change_payment_schedule_restricted_payments',
  CHANGE_PAYMENT_SCHEDULE_PAYMENT_OVERDUE = 'change_payment_schedule_payment_overdue',
  CHANGE_PAYMENT_SCHEDULE_MAX_CHANGES_IN_DURATION = 'change_payment_schedule_max_changes_in_duration',
  CHANGE_PAYMENT_SCHEDULE_TOO_CLOSE_TO_DUE_DATE = 'change_payment_schedule_too_close_to_due_date',
  CHANGE_PAYMENT_SCHEDULE_ACCOUNT_TOO_NEW = 'change_payment_schedule_account_too_new',
  CHANGE_PAYMENT_SCHEDULE_ACCOUNT_HARDSHIP = 'change_payment_schedule_account_hardship',
}
